<template>
<div class="setting_container">
    <div class="setting_wrapper">
    <div class="setting_tabs">
      <div class="setting_tab" :class="tab==1?'act':''" @click="tab=1">个人设置</div>
      <template v-if="userInfo && userInfo.role_id<=2">
        <div class="setting_tab" :class="tab==2?'act':''" @click="tab=2">企业设置</div>
      </template>
      
    </div>
    <div class="setting_contents">
      <div class="setting_content" v-if="tab==1">
        <div class="set_option">
          <div class="set_opt_attr">
            姓名
          </div>
          <div class="set_opt_desc">
            <div class="set_opt_item">
              {{userInfo && userInfo.username}}
            </div>
          </div>
          <div class="set_opt_handle">
            <el-popover
                offset="10"
                placement="left"
                :width="330"
                trigger="click"
                v-model:visible="isShowUsernamePop"
                popper-class="setUsernamePop"
              >
                <div class="setArea">
                  <div class="currentUsername">
                    当前姓名：{{ userInfo && userInfo.username }}
                  </div>
                  <div class="usernameInput">
                    <el-input
                      v-model="usernameInput"
                      input-style="border-radius:24px;width: 100%;height: 40px;background: #F6F9FD;"
                    />
                  </div>

                  <div class="setUsernameButton">
                    <div class="cancelButton" @click="isShowUsernamePop = false">
                      取消
                    </div>
                    <div class="confirmButton" @click="updateUsername">修改</div>
                  </div>
                </div>
                <template #reference>
                  <div class="set_opt_btn">编辑</div>
                </template>
              </el-popover>
          </div>
        </div>
        <div class="set_option">
          <div class="set_opt_attr">
            所属公司
          </div>
          <div class="set_opt_desc">
            <div class="set_opt_item">
              {{userInfo && userInfo.enterprise_name}}
            </div>
          </div>
          <div class="set_opt_handle">
            
          </div>
        </div>
        <div class="set_option">
          <div class="set_opt_attr">
            账号权限
          </div>
          <div class="set_opt_desc">
            <div class="set_opt_item">
              {{userInfo && ['超级管理员','管理员','成员'][userInfo.role_id*1-1]}}
            </div>
          </div>
          <div class="set_opt_handle">
            
          </div>
        </div>
        <div class="set_option">
          <div class="set_opt_attr">
            账号安全
          </div>
          <template v-if="sign_methods == 1">
            <div class="set_opt_desc">
              <div class="set_opt_item" v-if="userInfo && userInfo.mobile">
                <div class="set_opt_icon icon_success"></div>
                <div class="set_opt_text">当前已绑定手机 {{userInfo.mobile}}</div>
              </div>
              <div class="set_opt_item" v-else>
                <div class="set_opt_icon icon_fail"></div>
                <div class="set_opt_text">当前未绑定手机</div>
              </div>
              <div class="set_opt_item" v-if="userInfo && userInfo.bind_wechat>0">
                <div class="set_opt_icon icon_success"></div>
                <div class="set_opt_text">当前账号已绑定微信</div>
              </div>
              <div class="set_opt_item" v-else>
                <div class="set_opt_icon icon_fail"></div>
                <div class="set_opt_text">当前账号未绑定微信</div>
              </div>
            </div>
            <div class="set_opt_handle" v-if="userInfo && userInfo.bind_wechat==0">
              <el-popover
                placement="left"
                width="auto"
                trigger="click"
                @show="bindWx(0)"
              >
                <template #reference>
                  <div class="set_opt_btn">绑定微信</div>
                </template>
                <template #default>
                  <div id="wx_ewm" style="background: #000"></div>
                </template>
              </el-popover>
            </div>
          </template>
          <template v-if="sign_methods == 2">
            <div class="set_opt_desc">
              <div class="set_opt_item">已绑定邮箱：{{userInfo && userInfo.email}}</div>
            </div>
            <div class="set_opt_handle">
              <el-popover
                placement="left"
                width="auto"
                trigger="click"
                v-model:visible = "pwd_show"
              >
                <template #reference>
                  <div class="set_opt_btn" @click="pwd_show = true">修改邮箱登录密码</div>
                </template>
                <template #default>
                  <div class="pwd_modify">
                    <div class="modify_item">
                      <el-input
                        v-model.trim="pwd0"
                        type="password"
                        placeholder="请输入原密码"
                        maxlength=16
                        show-password
                      />
                    </div>
                    <div class="modify_item">
                      <el-input
                        v-model.trim="pwd1"
                        type="password"
                        placeholder="请输入新密码"
                        maxlength=16
                        show-password
                      />
                    </div>
                     <div class="modify_item">
                      <el-input
                        v-model.trim="pwd2"
                        type="password"
                        placeholder="请再次输入新密码"
                        maxlength=16
                        show-password
                      />
                    </div>
                    <div class="submit_btns">
                      <el-button 
                        class="submit_btn" 
                        type="primary" 
                        :loading="pwd_loading"
                        @click="modifyPwdFn"
                      >
                        确认修改
                      </el-button>
                    </div>
                  </div>
                </template>
              </el-popover>
            </div>
          </template>
          
        </div>
        <div class="set_option">
          <div class="set_opt_attr">
            账号操作
          </div>
          <div class="set_opt_desc">
            <div class="set_opt_item">
              登录操作记录
            </div>
          </div>
          <div class="set_opt_handle">
            <div class="set_opt_btn" @click="loadMore();">查看</div>
          </div>
        </div>

        <div class="set_table" v-if="look">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="登录时间" :width="250">
              <template #default="scope">
                {{scope.row.create_time}}
              </template>
            </el-table-column>
            <el-table-column prop="date" label="IP地址">
              <template #default="scope">
                {{scope.row.ip_addr}}
              </template>
            </el-table-column>
            <el-table-column prop="date" label="设备">
              <template #default="scope">
                {{scope.row.client}}
              </template>
            </el-table-column>
            <el-table-column prop="date" label="OS">
              <template #default="scope">
                {{scope.row.os}}
              </template>
            </el-table-column>
            <el-table-column prop="date" label="登录方式">
              <template #default="scope">
                {{scope.row.user_op}}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="setting_content" v-if="tab==2">
        <div class="set_option">
          <div class="set_opt_attr">
            企业名称
          </div>
          <div class="set_opt_desc">
            <div class="set_opt_item">
              {{userInfo && userInfo.enterprise_name}}
            </div>
          </div>
          <div class="set_opt_handle">
            
          </div>
        </div>
        <div class="set_option">
          <div class="set_opt_attr">
            账号期限
          </div>
          <div class="set_opt_desc">
            <div class="set_opt_item">
              {{userInfo && userInfo.failure_date}}  
            </div>
          </div>
          <div class="set_opt_handle">
            
          </div>
        </div>
        <div class="set_option">
          <div class="set_opt_attr">
            账号授权数量
          </div>
          <div class="set_opt_desc">
            <div class="set_opt_item">
              {{userInfo && userInfo.enterprise_member_limit}}  
            </div>
          </div>
          <div class="set_opt_handle">
            
          </div>
        </div>
        <div class="set_account_option">
          <div class="set_account_attr">账号列表（{{enterpriseInfo && enterpriseInfo.count || 0}}/{{userInfo && userInfo.enterprise_member_limit}}）</div>
          <div class="set_account_btn" @click="addMemberDrawer = true">增加账号</div>
        </div>
        <div class="set_table2">
          <el-table :data="enterpriseInfo && enterpriseInfo.list" style="width: 100%">
            <el-table-column label="ID" type="index">
            </el-table-column>
            <el-table-column label="登录账号">
              <template #default="scope">
                {{scope.row.mobile || scope.row.email}}
              </template>
            </el-table-column>
            <el-table-column label="姓名">
              <template #default="scope">
                {{scope.row.username}}
              </template>
            </el-table-column>
            <el-table-column label="部门">
              <template #default="scope">
                {{scope.row.department}}
              </template>
            </el-table-column>
            <el-table-column label="角色">
              <template #default="scope">
                {{scope.row.role}}
              </template>
            </el-table-column>
            <el-table-column label="备注">
              <template #default="scope">
                {{scope.row.remarks}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="50">
              <template #default="scope">
                <el-popconfirm
                  title="确认删除成员吗?"
                  @confirm="deleteMember(scope.row.uid)"
                  confirm-button-text="是"
                  cancel-button-text="否"
                   v-if="scope.row.role_id>2"
                >
                  <template #reference>
                    <div class="del_btn">删除</div>
                  </template>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-drawer
      v-model="addMemberDrawer"
      title="增加账号"
      direction="rtl"
      :before-close="handleClose"
      :size="'auto'"
      modal-class="modal_transparent"
    >
      <!-- <div class="addDrawer">
        <div class="addMemberText">添加成员</div>
        <div class="addMemberTip">
          发送邀请后，将通过短信告知成员，该成员可直接通过手机号访问系统
        </div>
        <div class="addMemberInput">
          <el-input
            v-model="mobile"
            placeholder="请输入手机号"
            class="input-with-select"
            input-style="border-top-left-radius: 12px;border-bottom-left-radius: 12px;background: #F8F8F8;"
          >
            <template #append>
              <el-select
                v-model="role"
                @change="changeRole"
                placeholder="Select"
                style="width: 110px"
                class="fff"
              >
                <el-option label="管理员" value="2"></el-option>
                <el-option label="超级管理员" value="1"></el-option>
                <el-option label="测试员" value="3"></el-option>
              </el-select>
            </template>
          </el-input>

          <el-date-picker
            v-if="expireDateShow"
            v-model="expireDate"
            type="date"
            placeholder="选择失效时间"
            :editable="false"
            :disabled-date="disabledDate"
            :shortcuts="shortcuts"
            style="width: 100%; --el-border-radius-base: 10px; margin-top: 15px"
          >
          </el-date-picker>
        </div>
        <button
          class="addSaveBtn"
          v-if="countDown.isFinished"
          @click="getMobileCode"
        >
          添加
        </button>
        <div v-else class="addSaveBtn disabled flex flex-center">
          继续添加({{ countDown.duration }}s)
        </div>
      </div> -->
      <div class="add_account">
        <div class="account_types">
          <div class="account_type" :class="account_type == 1 ?'act':''" @click="account_type = 1">
            邮箱登录
          </div>
          <div class="account_type" :class="account_type == 2 ?'act':''" @click="account_type = 2">
            手机号登录
          </div>
        </div>
        <div class="account_group">
          <div class="account_item account_item_email" v-if="account_type == 1">
            <div class="item_attr">
              邮箱:
            </div>
            <div class="item_val">
              <input type="text" v-model.trim="add_email" class="input_email"><span>@{{userInfo.enterprise_email}}</span>
            </div>
          </div>
          <div class="account_item account_item_tel" v-if="account_type == 2">
            <div class="item_attr">
              手机号:
            </div>
            <div class="item_val">
              <input type="text" v-model.trim="add_tel">
            </div>
          </div>
          <div class="account_item">
            <div class="item_attr">
              姓名:
            </div>
            <div class="item_val">
              <input type="text" v-model.trim="add_name">
            </div>
          </div>
          <div class="account_item">
            <div class="item_attr">
              部门:
            </div>
            <div class="item_val">
              <input type="text" v-model.trim="add_section">
            </div>
          </div>
          <div class="account_item">
            <div class="item_attr">
              备注:
            </div>
            <div class="item_val">
              <input type="text" v-model.trim="add_remark">
            </div>
          </div>
          <div class="add_desc_text">
            发送邀请后，将通过短信告知成员，该成员可直接通过手机号访问系统
          </div>
          <div class="add_account_btn" @click="addFn">提交</div>

        </div>
      </div>


    </el-drawer>
  </div>
</div>

</template>

<script>
import { 
  onMounted, 
  ref, 
  reactive,
  onUnmounted,
  watch
} from 'vue';
import {
  useRoute
} from 'vue-router'
import {
  getUserInfo,
  getOplog,
  getTeamList,
  updateUserInfo,
  invitationGetMobileCode,
  deleteMemberByUid,
  modifyPwd,
  addMember
} from '@/api';

import store from "@/store";
import { getCookie } from "@/plugins/cookie";
import {
  ElMessage,
  ElTable,
  ElTableColumn,
  ElPopover,
  ElInput,
  ElDrawer,
  // ElSelect,
  // ElOption,
  // ElDatePicker,
  ElPopconfirm,
  ElButton
} from 'element-plus';
export default {
  components:{
    ElTable,
    ElTableColumn,
    ElPopover,
    ElInput,
    ElDrawer,
    // ElSelect,
    // ElOption,
    // ElDatePicker,
    ElPopconfirm,
    ElButton
  },
  setup(){
    const route = useRoute();
    console.log(route.query);
    const tab=ref(route.query.mode || 1);
    const look = ref(false);
    const sign_methods = ref(getCookie("sign_methods")||1);
    let loading = false;
    let hasMore = true;
    let page = 1;
    let size = 20;
    const tableData = ref([]);
    const loadMore = ()=>{
      if(!look.value && hasMore){
        look.value=true;
        loading = true;
        getOplog({
          page,
          size
        }).then(res=>{
          tableData.value.push(...res.data.list);
          page++;
          if(page>res.data.total_page){
            hasMore=false;
          }
          loading=false;
        })
      }
    }
    const handleScroll = ()=>{
      //1.获取滚动区域元素
      let contentWrap = document.querySelector(".el-main");
      if (contentWrap) {
        //2.获取元素高度
        let height = contentWrap.offsetHeight;
        //3.获取滚动区域到头部的距离
        let top = contentWrap.scrollTop;
        //4.获取滚动条高度
        let scrollHeight = contentWrap.scrollHeight;
        //5.滚动条到底部的条件 (滚动区域到头部的距离 + 屏幕高度 = 可滚动的总高度)
        if (top + height >= scrollHeight && !loading && hasMore && look.value==true) {
          loadMore();
        }
      }
    }
    onMounted(()=>{
      document.querySelector(".el-main").addEventListener("scroll", handleScroll, false);
    })
    const wxBindEwm = () => {
      window.WxLogin &&
        new window.WxLogin({
          self_redirect: true,
          id: "wx_ewm",
          appid: "wx69bd175a495a316f",
          scope: "snsapi_login",
          redirect_uri: encodeURIComponent("https://ceping.cheyun.com/bind_ewm"),
          state: "",
          style: "white",
          href: "",
        });
    };
    const bindWx = (state) => {
      if (state) {
        console.log("已绑定微信");
      } else {
        console.log("未绑定");
        wxBindEwm();
      }
    };
    window.bindSuccess = ()=>{
      ElMessage.success("绑定成功!");
    }
    window.bindFailed = (res)=>{
      wxBindEwm();
      if(res && res.message){
        ElMessage.error(res.message)
      }else{
        ElMessage.error("失败，请重试！");
      }
    }
    onUnmounted(()=>{
      delete(window.bindSuccess);
      delete(window.bindFail);
    }) 
    const userInfo = ref(null);
    const enterpriseInfo = ref(null);
    const getInfoFn = ()=>{
      getUserInfo().then(res=>{
        userInfo.value = res.data;
      })
    }
    const getTeamListFn = ()=>{
      getTeamList().then(res=>{
        console.log(res);
        enterpriseInfo.value = res.data;
      })
    }
    getInfoFn();
    getTeamListFn();
    const isShowUsernamePop = ref(false);
    const usernameInput = ref("");
    const updateUsername = () => {
      if (usernameInput.value == "") {
        ElMessage.error("姓名不可为空!");
        return false;
      }
      updateUserInfo({ username: usernameInput.value }).then((res) => {
        if (res.code == 200) {
          ElMessage.success("修改成功!");
          store.updateCookie("username", usernameInput.value);
          store.updateUsername(usernameInput.value);
          userInfo.value.username = usernameInput.value;
          isShowUsernamePop.value = false;
        } else {
          ElMessage.error(res.message || "修改失败!");
        }
      });
    };
    const addMemberDrawer = ref(false);
    const mobile = ref("");
    const role = ref("2");
    const expireDate = ref("");
    const expireDateShow = ref(false);
    let failure_time = "";
    const changeRole = (value) => {
      if (value == 3) {
        expireDateShow.value = true;
      } else {
        expireDateShow.value = false;
      }
    };
    const disabledDate = (time) => {
      if (failure_time == "") {
        let failure_date = new Date(getCookie("failure_date"));
        failure_time = failure_date.getTime();
      }
      return (
        time.getTime() < Date.now() - 86400000 || time.getTime() > failure_time
      );
    };
    const countDown = reactive({
      timer: null,
      duration: 60,
      isFinished: true,
    });
    const telreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    const getMobileCode = () => {
      if (!countDown.isFinished) {
        return;
      }
      if (!mobile.value) {
        ElMessage.error("请输入手机号!");
        return false;
      }
      if (!telreg.test(mobile.value)) {
        ElMessage.error("请输入正确的手机号码!");
        return false;
      }
      countDown.timer && clearInterval(countDown.timer);
      countDown.isFinished = false;
      countDown.timer = setInterval(() => {
        const time = countDown.duration--;
        if (time <= 0) {
          clearInterval(countDown.timer);
          countDown.duration = 60;
          countDown.isFinished = true;
        }
      }, 1000);
      let params = {
        mobile: mobile.value,
        role_id: role.value,
      };
      if (params.role_id == 3) {
        if (!expireDate.value) {
          ElMessage.error("请选择失效日期!");
          return false;
        }
        params["failure_date"] = expireDate.value.getTime();
      }
      invitationGetMobileCode(params)
      .then((res) => {
        if (res.code == 200) {
          ElMessage.success("发送成功!");
          getTeamListFn();
        } else {
          ElMessage.error(res.message || "获取验证码失败，请稍后重试!");
          countDown.timer && clearInterval(countDown.timer);
          countDown.duration = 60;
          countDown.isFinished = true;
        }
      })
      .catch((err) => {
        console.log(err);
        ElMessage.error("获取验证码失败，请重试!");
        countDown.timer && clearInterval(countDown.timer);
        countDown.duration = 60;
        countDown.isFinished = true;
      });
    };

    const deleteMember = (uid) => {
      deleteMemberByUid({ uid: uid }).then((res) => {
        if (res.code == 200) {
          ElMessage.success("操作成功!");
          getTeamListFn();
        }
      });
    };
    const pwd0 = ref("");
    const pwd1 = ref("");
    const pwd2 = ref("");
    const pwd_loading = ref(false);
    const modifyPwdFn = ()=>{
      console.log(1);
      pwd_loading.value=true;
      if(!pwd0.value){
        ElMessage.warning("请输入旧密码！");
        return;
      }
      if(!pwd1.value){
        ElMessage.warning("请输入新密码！");
        return;
      }
      if(!pwd2.value){
        ElMessage.warning("请再次输入新密码！");
        return;
      }
      const reg1 = /^\S*$/;
      if(!reg1.test(pwd1.value)){
        ElMessage.warning("密码不可包含空格！");
        return;
      }
      if(pwd1.value != pwd2.value){
        ElMessage.warning("两次输入不一致！");
        return;
      }
      if(pwd1.value.length<8 || pwd1.value.length>16){
        ElMessage.warning("密码长度为8—16位！");
        return;
      }
      const reg2 = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.+$/g;
      if(!reg2.test(pwd1.value)){
        ElMessage.warning("需包含数字中至少两种字符！");
        return;
      }
      modifyPwd({
        old_pwd:pwd0.value,
        pwd:pwd1.value,
        re_pwd:pwd2.value
      }).then(res=>{
        if(res && res.code && res.code == 200){
          pwd0.value = "";
          pwd1.value = "";
          pwd2.value = "";
          pwd_show.value=false;
          pwd_loading.value = false;
          ElMessage.success("修改成功！");
        }else{
          pwd_loading.value = false;
          ElMessage.warning(res.message || "修改失败，请重试！");
        }
      })
    }
    watch(()=>route.query.mode,(new_val)=>{
      tab.value = new_val;
    })

    const account_type = ref(1);
    const add_email = ref("");
    const add_tel = ref("");
    const add_name = ref("");
    const add_section = ref("");
    const add_remark = ref("");
    let sub_loading = false;
    const addFn = ()=>{
      if(sub_loading){
        return ;
      }
      if(account_type.value == 1){
        if(!add_email.value){
          ElMessage.warning("请输入邮箱号！");
          return;
        }
      }
      if(account_type.value == 2){
        if(!add_tel.value){
          ElMessage.warning("请输入手机号！");
          return;
        }
        if(!telreg.test(add_tel.value)){
          ElMessage.warning("请输入正确的手机号！");
          return;
        }
      }
      if(!add_name.value){
        ElMessage.warning("请输入姓名！");
        return;
      }
      sub_loading = true;
      addMember({
        email:account_type.value == 1?add_email.value+'@'+userInfo.value.enterprise_email:'',
        mobile:account_type.value == 2?add_tel.value:'',
        username:add_name.value,
        department:add_section.value,
        remarks:add_remark.value,
      }).then(res=>{
        if(res && res.code && res.code==200){
          ElMessage.success("增加账号成功！");
        }
        sub_loading = false;
        add_email.value = "";
        add_tel.value = "";
        add_name.value = "";
        add_section.value = "";
        add_remark.value = "";
        addMemberDrawer.value = false;
        getTeamListFn();
      }).catch(()=>{
        ElMessage.error("增加账号失败，请重试！");
        sub_loading = false;
      })

      
    }

    const pwd_show = ref(false);

    return {
      sign_methods,
      tab,
      tableData,
      bindWx,
      userInfo,
      enterpriseInfo,
      look,
      loadMore,

      isShowUsernamePop,
      usernameInput,
      updateUsername,

      addMemberDrawer,
      mobile,
      role,
      changeRole,
      expireDate,
      expireDateShow,
      disabledDate,
      getMobileCode,
      countDown,

      deleteMember,

      pwd0,
      pwd1,
      pwd2,
      modifyPwdFn,
      loading,

      account_type,
      add_email,
      add_tel,
      add_name,
      add_section,
      add_remark,
      addFn,
      pwd_show
    }
  }
}
</script>

<style lang="less" scoped>
.setting_container{
  width: 100vw;
}
.setting_wrapper{
  margin: 0 auto;
  width: 1200px;
  min-height: calc(100vh - 150px);
  background: #FFFFFF;
  border-radius: 2px;
  padding: 32px 56px 50px 59px;
  .setting_tabs{
    display: flex;
    align-items: center;
    .setting_tab{
      width: 102px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 18px;
      font-weight: 400;
      color: #000000;
      text-align: center;
      margin-right: 30px;
      cursor: pointer;
      &.act{
        font-weight: bold;
        border-bottom: 2px solid #1FBCBF;
      }
    }
  }
  .setting_contents{
    margin-top: 28px;
    width: 100%;
    .setting_content{
      .set_option{
        width: 100%;
        padding: 8px 30px 8px 16px;
        margin-bottom: 9px;
        background: #F6F9FD;
        border-radius: 4px;
        display: flex;
        .set_opt_attr{
          width: 102px;
          height: 37px;
          line-height: 37px;
          flex-shrink: 0;
          font-size: 14px;
          font-weight: bold;
          color: #000000;
        }
        .set_opt_desc{
          flex-grow: 1;
          .set_opt_item{
            height: 37px;
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 400;
            color: #000000;
            .set_opt_icon{
              width: 15px;
              height: 15px;
              &.icon_success{
                background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/success_20230116.png) no-repeat center center;
                background-size: 100%;
              }
              &.icon_fail{
                background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/fail_20230116.png) no-repeat center center;
                background-size: 100%;
              }
            }
            .set_opt_text{
              margin-left: 10px;
            }
          }
        }
        .set_opt_handle{
          align-self: flex-end;
          .set_opt_btn{
            cursor: pointer;
            height: 37px;
            line-height: 37px;
            font-size: 14px;
            font-weight: 400;
            color: #1FBCBF;
          }
        }
      }
      .set_account_option{
        margin-top: 16px;
        padding-left: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .set_account_attr{
          font-size: 14px;
          font-weight: bold;
          color: #000000;
        }
        .set_account_btn{
          cursor: pointer;
          width: 104px;
          height: 37px;
          line-height: 37px;
          text-align: center;
          border-radius: 5px;
          border: 1px solid #CDCDCD;
          font-size: 14px;
          font-weight: bold;
          color: #000000;
        }
      }
    }
  }
}
.set_table{
  width: 100%;
  margin: 37px auto 0;
}
.set_table2{
  width: 100%;
  margin: 37px auto 0;
}
:deep(.el-table .cell){
  font-size: 12px;
  font-weight: 400;
  color: #000000;
}
.del_btn{
  font-size: 12px;
  font-weight: 400;
  color: #3070FF;
  cursor: pointer;
}

.setUsernamePop {
  height: 225px;
  box-shadow: 12px 11px 45px 0px rgba(208, 224, 246, 0.41);
  border-radius: 14px;
  border: 1px solid #d8e2f0;
  padding: 40px;
}
 .setArea {
    padding: 0px 27px 10px;
    .setMoible {
      height: 26px;
      font-size: 18px;
      font-weight: bold;
      color: #666666;
      line-height: 26px;
      margin-top: 15px;
      margin-bottom: 13px;
      display: flex;
      align-items: center;
    }
    .setAccount {
      margin-top: 28px;
    }
    .setExpire {
      margin-top: 22px;
    }
    .setRow {
      display: flex;
      justify-content: space-between;
    }
    .setLeft {
      font-size: 15px;
      font-weight: 400;
      color: #999;
      line-height: 21px;
    }
    .setRight {
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: 400;
      color: #666666;
      line-height: 21px;
    }
    .signOutBtn {
      margin-top: 22px;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 4px;
      background: #fd8f8f;
      color: #fff;
    }
    .currentUsername {
      width: 200px;
      height: 21px;
      font-size: 16px;
      color: #464646;
      line-height: 21px;
      margin-top: 30px;
    }
  }
  .usernameInput {
  margin-top: 27px;
}
.setUsernameButton {
  margin-top: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cancelButton {
  width: 84px;
  height: 35px;
  background: #b4b9bf;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.confirmButton {
  margin-left: 13px;
  width: 84px;
  height: 35px;
  background: #1FBCBF;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.addDrawer {
  width: 537px;
  padding: 53px;
}
.addMemberText {
  width: 96px;
  height: 33px;
  font-size: 24px;
  font-weight: bold;
  color: #2b2b2b;
  line-height: 33px;
}
.addMemberTip {
  margin-top: 16px;
  width: 434px;
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #777c89;
  line-height: 20px;
}
.addMemberInput {
  margin-top: 35px;
  :deep(.el-input .el-input__inner) {
    border-top-left-radius: 6px !important;
    border-bottom-left-radius: 6px !important;
  }
  :deep(.el-input-group__append) {
    border-top-right-radius: 6px !important;
    border-bottom-right-radius: 6px !important;
  }
}
.addSaveBtn {
  margin-top: 31px;
  width: 432px;
  height: 44px;
  background: #eef1fc;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #706ee7;
  border: none;
  cursor: pointer;
}

.pwd_modify{
  width:250px;
  .modify_item{
    margin-bottom: 10px;
  }
  .submit_btns{
    display: flex;
    justify-content: center;
  }
  .submit_btn{
    margin: 0 auto;
    width: 135px;
    height: 35px;
    background: #1FBCBF;
    border-radius: 2px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 35px;
    text-align: center;
    padding: 0 20px;
  }
}

.add_account{
  width: 100%;
  padding: 30px 20px 0;
  .account_types{
    display: flex;
    align-items: center;
    .account_type{
      width: 102px;
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      font-weight: 400;
      color: #000000;
      text-align: center;
      margin-right: 30px;
      cursor: pointer;
      &.act{
        font-weight: bold;
        border-bottom: 2px solid #1FBCBF;
      }
    }
  }
  .account_group{
    padding: 10px;
    .account_item{
      display: flex;
      align-items: center;
      padding-top: 20px;
      .item_attr{
        width: 60px;
        font-size: 16px;
        text-align: justify;
        text-align-last: justify;
        margin-right: 20px;
      }
      .item_val{
        width: 300px;
        height: 40px;
        display: flex;
        align-items: center;
        input{
          width: 100%;
          height: 100%;
          border: none;
          outline: none;
          background: #F4F4F4;
          border-radius: 6px;
          padding-left: 20px;
          &.input_email{
            width: 170px;
            margin-right: 10px;
          }
        }
      }
    }
    .add_desc_text{
      color: #666;
      margin-top: 20px;
      font-size: 12px;
    }
    .add_account_btn{
      cursor: pointer;
      width: 200px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 18px;
      color:#fff;
      background: #1FBCC5;
      border-radius: 6px;
      margin: 35px auto;
    }
  }

}
</style>